<template>
  <portal to="popup">
    <transition name="menu">
      <div class="menu" v-if="show">
        <h3>{{ title }}</h3>
        <div class="item" v-for="({ name, value}, index) of options" :key="index" @click="$emit('select', value)">
          {{ name }}
        </div>
        <div class="close" @click="$emit('close')">
          <Icon type="close-circle-o" />
        </div>
      </div>
    </transition>
  </portal>
</template>

<script>
import Icon from '@/components/Icon'

export default {
  name: 'FullScreenMenu',
  props: ['show', 'title', 'options'],
  components: {
    Icon,
  },
}
</script>

<style lang="less" scoped>
.menu {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  flex-direction: column;
  z-index: 500;
  h3 {
    font-size: 24px;
    text-transform: capitalize;
    margin: 1em 0;
    padding: 1em 0;
    border-bottom: 2px solid #fbfbfb;
    width: 280px;
  }
  .item {
    margin: 6px 0;
    padding: 12px 0;
    font-size: 14px;
    width: 240px;
    background: hsl(0, 0%, 35%);
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      background: hsl(0, 0%, 40%);
    }
  }
  .close {
    font-size: 24px;
    border-top: 2px solid #fbfbfb;
    margin-top: 24px;
    width: 280px;
    padding: 1em 0;
  }
}
.menu-enter-active, .menu-leave-active {
  transition: opacity 200ms ease;
}
.menu-enter, .menu-leave-to {
  opacity: 0;
}
</style>
